import { type MutationHookOptions, useMutation } from "@apollo/client";
import { SignOutMutation } from "./../graphql/mutations";

export const useSignOut = (options?: MutationHookOptions) => {
  return useMutation(SignOutMutation, {
    onCompleted: () => {
      localStorage.removeItem("token");
      window.location.reload();
    },
    ...options,
  });
};
